import React from 'react';
import CookiesModal from './CookiesModal';
import { useModal } from './useModal';

export interface ReturnType {
  onPresentCookiesModal: () => void;
  removeCookiesModal: () => void;
}

export interface ICookiesModalProps {
  onCookiesAccept: () => void;
  onCookiesDecline?: () => void;
  delayInSeconds?: number;
  onTermsClicked?: () => void;
}

const useCookiesModal = ({
  onCookiesAccept,
  onCookiesDecline,
  delayInSeconds,
  onTermsClicked
}: ICookiesModalProps): ReturnType => {
  const [onPresentCookiesModal, removeCookiesModal] = useModal(
    <CookiesModal
      onCookiesAccept={() => onCookiesAccept()}
      onDismiss={onCookiesDecline}
      delayInSeconds={delayInSeconds}
      onTermsClicked={onTermsClicked}
    />
  );
  return { onPresentCookiesModal, removeCookiesModal };
};

export default useCookiesModal;
